<template>
  <template v-for="(item, index) in source" :key="item">
    <a-tag color="blue">
      <template #icon>
        <a-space :gutter="5" style="margin-right: 10px;">
          <a-popconfirm title="确定删除吗？" @confirm="() => close(item, index)">
            <huasky-icon icon="CloseOutlined" />
          </a-popconfirm>
          <huasky-icon icon="EditOutlined" @click="() => edit(item, index)" />
        </a-space>
      </template>
      {{ item }}
    </a-tag>
  </template>
  <a-input v-if="inputVisible" ref="$inputRef" v-model:value.trim="inputValue" type="text" size="small"
    :style="{ width: '78px' }" @blur="onBlur" @keyup.enter="confirm" />
  <a-tag v-else class="add" @click="showInput">
    <huasky-icon icon="PlusOutlined" />
    新增
  </a-tag>
</template>
<script setup lang="ts">
import { saveDataDic } from '@src/scripts/api/setting'
import { saveAppData } from '@src/scripts/system'
import { DataDicGroup } from '@src/scripts/type'
import { onMounted, ref, nextTick } from 'vue'

const props = defineProps<{
  group: DataDicGroup
}>()

const inputVisible = ref(false)
const inputValue = ref('')
const $inputRef = ref()

let editIndex: number       // 记录编辑时的标签序号

const source = ref<string[]>([])
const curDic = ref<DataDic>(null)

const showInput = () => {
  inputVisible.value = true
  editIndex = -1
  nextTick(() => $inputRef.value.focus())
}

const edit = (item: string, index: number) => {
  inputVisible.value = true
  inputValue.value = item
  editIndex = index
  nextTick(() => $inputRef.value.focus())
}

const onBlur = () => {
  inputVisible.value = false
  inputValue.value = ''
}

const confirm = async () => {
  debugger
  if (!inputValue.value) return
  if (editIndex > -1) {
    source.value[editIndex] = inputValue.value
  } else {
    source.value.push(inputValue.value)
  }
  curDic.value.info = JSON.stringify(source.value)
  const { data } = await saveDataDic(curDic.value)
  curDic.value.id = data.id
  saveAppData()
  onBlur()
}

const close = async (item: string, index: number) => {
  source.value.splice(index, 1)
  curDic.value.info = JSON.stringify(source.value)
  await saveDataDic(curDic.value)
  saveAppData()
}

onMounted(() => {
  curDic.value = $app.dic.allDic.first(a => a.group === props.group) ?? { group: props.group, name: $util.getDicGroupName(props.group), sort: $app.dic.allDic.genSort(a => a.sort), info: '[]'}
  source.value = JSON.parse(curDic.value.info)
})

</script>
<style scoped lang="scss">
.add {
  background: #fff;
  border-style: dashed;
  cursor: pointer;
}

:deep(.anticon) {
  opacity: .8;
  cursor: pointer;
}
</style>